import React from "react";

export default function LinkedinBlackIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.07727 12.6863H0.518331V4.44582H3.07727V12.6863ZM1.79642 3.32174C0.978157 3.32174 0.314453 2.64398 0.314453 1.82572C0.314453 1.43268 0.470589 1.05573 0.748512 0.777809C1.02644 0.499886 1.40338 0.34375 1.79642 0.34375C2.18947 0.34375 2.56641 0.499886 2.84433 0.777809C3.12226 1.05573 3.27839 1.43268 3.27839 1.82572C3.27839 2.64398 2.61441 3.32174 1.79642 3.32174ZM12.6546 12.6863H10.1011V8.6749C10.1011 7.71888 10.0818 6.49286 8.77069 6.49286C7.44025 6.49286 7.23637 7.53154 7.23637 8.60603V12.6863H4.68019V4.44582H7.13443V5.5699H7.17025C7.51188 4.92245 8.3464 4.23919 9.59143 4.23919C12.1812 4.23919 12.6573 5.9446 12.6573 8.1597V12.6863H12.6546Z" fill="#020E27"/>
</svg>

  );
}
